export default __webpack_public_path__ + "fonts/Aeonik-Medium_928b7a86ef5c790cbd93c5808f95e3a2.woff";